function componentKlaviyo(){
  const form = document.getElementById('klaviyo-newsletter-form');
  const flash = document.getElementById('klaviyo-newsletter-flash');
  const email = document.getElementById('klaviyo-newsletter-email');
  const success = document.getElementById("klaviyo-newsletter-success");
  const error = document.getElementById("klaviyo-newsletter-error");
  const submitting = document.getElementById("klaviyo-newsletter-submitting");

  const validate = function() {
    let v = email.value;
    if (v) {
      if (/^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v)){
        return true;
      }
    }
    return false;
  }

  const showError = function() {
    flash.style.display = "block";
    setTimeout(function(){
      flash.style.display = "none";
    }, 3000);
  }

  const formSubmit = function(event) {
    event.preventDefault();
    // Check we have an email
    if (!validate()) {
      showError();
      return false;
    }
    flash.style.display = "none";
    form.style.display = "none";
    submitting.style.display = "block";

    // Submit form to Klaviyo
    const data = { 
        "email": email.value,
        "g": "VTrBBs", // New Subscribers Welcome Discount
        "$source": "Custom Newsletter Form", 
    };
    let formBody = [];
    for (var property in data) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(data[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
      method: "POST",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: formBody,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
        submitting.style.display = "none";
        if (data.success){
            success.style.display = "block";
        } else {
            error.style.display = "block";
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        submitting.style.display = "none";
        error.style.display = "block";
      });

  }

  form.addEventListener("submit", formSubmit);
}

document.addEventListener('DOMContentLoaded', function () {
  componentKlaviyo();
}, false);
